/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from "@ember/object";
import Component from "@glimmer/component";
import move from "ember-animated/motions/move";
import { fadeIn, fadeOut } from "ember-animated/motions/opacity";
import { BufferedChangeset } from "ember-changeset/types";
/**
 * This component helps handle list of things in a component.
 * This helper provides the logic for handling lists:
 * - adding an item,
 * - deleting one,
 * - moving items (coming later).
 *
 * The model is usually a changeset.
 */
let ModelListComponent = (_class = class ModelListComponent extends Component {
  get isChangesetBased() {
    return Boolean(this.args.model);
  }
  get changesetBasedArgs() {
    return this.args;
  }
  get listBasedArgs() {
    return this.args;
  }
  get items() {
    if (this.isChangesetBased) {
      return this.changesetBasedArgs.model.get(this.changesetBasedArgs.propertyName);
    }
    return this.listBasedArgs.items;
  }
  get lastItemIndex() {
    return Math.max(0, this.items.length - 1);
  }
  addItem() {
    this.addItemObject(this._createItem());
  }
  addItemObject(obj) {
    this._updateList(list => {
      list.push(obj);
    });
  }
  destroyItem(index) {
    if (this.args.onDestroyItem) {
      this.args.onDestroyItem(index);
    }
    this._updateList(list => {
      list.splice(index, 1);
    });
  }
  moveItemUp(index) {
    if (index == 0) return;
    this._updateList(items => {
      const item = items[index];
      items.splice(index, 1);
      items.splice(index - 1, 0, item);
    });
  }
  moveItemDown(index) {
    if (index == this.items.length - 1) return;
    this._updateList(items => {
      const item = items[index];
      items.splice(index, 1);
      items.splice(index + 1, 0, item);
    });
  }
  *transition({
    insertedSprites,
    keptSprites,
    removedSprites
  }) {
    for (const sprite of insertedSprites) {
      fadeIn(sprite);
    }
    for (const sprite of keptSprites) {
      move(sprite);
    }
    for (const sprite of removedSprites) {
      fadeOut(sprite);
    }
    yield;
  }

  /**
   * Calls the given constructor if it exists
   * or create an empty POJO.
   */
  _createItem() {
    return this.args.createItem ? this.args.createItem() : {};
  }
  _updateList(operation) {
    if (this.isChangesetBased) {
      const items = this.changesetBasedArgs.model.get(this.changesetBasedArgs.propertyName).slice(0);
      operation(items);
      this.changesetBasedArgs.model.set(this.changesetBasedArgs.propertyName, items);
    } else {
      const items = this.listBasedArgs.items.slice();
      operation(items);
      this.listBasedArgs.onUpdateItems(items);
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "addItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroyItem", [action], Object.getOwnPropertyDescriptor(_class.prototype, "destroyItem"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "moveItemUp", [action], Object.getOwnPropertyDescriptor(_class.prototype, "moveItemUp"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "moveItemDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "moveItemDown"), _class.prototype), _class);
export { ModelListComponent as default };